<div class="p-7 w-[400px] max-w-[90vw]">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2 m-0">Move To</p>
  <p class="text-sm text-[var(--base-text-alt-dark)] leading-relaxed">
    Move selected sample(s) to chosen group below.
  </p>
  <form [formGroup]="newGroupForm" class="mt-4">
    <div class="flex items-end gap-2">
      <mat-form-field class="flex-1" appearance="outline">
        <mat-label>Group</mat-label>
        <mat-select formControlName="sampleGroup">
          <mat-option style="background-color: white!important; padding: 8px!important">
            <div class="select-search-container-sm">
              <div class="select-search-sm">
                <ngx-mat-select-search placeholderLabel="Search Group" [formControl]="groupFilterCtrl">
                  <span ngxMatSelectNoEntriesFound>No entries found</span>
                </ngx-mat-select-search>
              </div>
            </div>
          </mat-option>
          <mat-option *ngFor="let group of filteredSampleGroups | async | orderBy: 'name'" [value]="group" (click)="setSelectedGroup(group)">
            {{group.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button type="button" (click)="addNewGroup()"
        class="w-9 h-9 mb-5 rounded-lg bg-[var(--primary-dark)] border-none flex items-center justify-center cursor-pointer hover:opacity-90">
        <span class="material-icons text-white text-[20px]">add</span>
      </button>
    </div>
  </form>
  <div class="flex justify-end gap-3 mt-4">
    <button (click)="close()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
    <button (click)="move()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">Move</button>
  </div>
</div>
